
import { ApiGatewayApi } from "../api";
import { Credentials } from "../auth";

import { CredentialsProvider } from "auth/modules/sagas/CredentialsProvider";
import { getString, getType } from "utils/Utils";

export type ApiCredentials = Credentials | { credentials: Credentials };
export type AccessToken = string | { accessToken?: string };

/**
 * Retrieves a new API with the given credentials.
 * @param creds  The credentials to pass.
 */
export function getApi(creds: ApiCredentials, accessToken?: AccessToken) {
    const credentials: Credentials = getType(creds, "credentials", (item: any) => item.credentials === undefined);
    const askToken = getString(accessToken, "accessToken");
    return new ApiGatewayApi(new CredentialsProvider(credentials, askToken));
}

/**
 * Will parse a url containing ":<value>" syntax and
 * assign it to the given value in the object.
 * @param url The original URL to parse.
 * @param obj The object to retrieve the values from.
 */
export function parseString(url: string, obj: any) {
    if (!obj) {
        return url;
    }
    let realString = url;
    Object.keys(obj).forEach((key: string) => {
        const value = obj[key];
        if (value && typeof value !== "string") {
            throw new Error("Value of " + key + " is not a string and could not be parsed in to a string.");
        }
        realString = realString.replace(":" + key, obj[key]);
    });
    return realString;
}
